module.exports = __webpack_public_path__ + "static/media/d5kz.f8e330ba.pdf";